<template>
  <div>
    <page-title>Banner Management</page-title>

    <loading v-if="loading" />
    <div v-else>
      <section-block>
        <template slot="header">
          <filter-bar
            resource="Slider"
            :search-query="searchQuery"
            show-search
          ></filter-bar>
        </template>

        <template slot="actions">
          <base-button
            :primary="true"
            @click="$router.push({ name: 'AdminBannerCreate' })"
            iconBefore="document-create"
          >
            <span>Create a banner</span>
          </base-button>
        </template>

        <vuetable
          class="c-data-table"
          :api-mode="false"
          :fields="table.fields"
          :data-manager="dataManager"
          pagination-path
          ref="bannerTable"
          @vuetable:pagination-data="onPaginationData"
          :row-class="onRowClass"
        >
          <template slot="title" slot-scope="props">
            <span v-if="props.rowData.name">{{ props.rowData.name }}</span>
            <span v-else>Not set</span>
          </template>
          <template slot="date-created" slot-scope="props">
            <base-datetime :date="props.rowData.created_time"></base-datetime>
          </template>

          <template slot="category-actions" slot-scope="props">
            <banner-actions
              routePath="AdminBannerEdit"
              type="Banner"
              :id="props.rowData.id"
              deleteAction="Banner/deleteSlider"
              :rowData="props.rowData"
              @tableUpdate="updateTable"
            />
          </template>
        </vuetable>
        <pagination table-pagination>
          <vuetable-pagination
            ref="pagination"
            @vuetable-pagination:change-page="onChangePage"
          ></vuetable-pagination>
        </pagination>
      </section-block>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapState } from "vuex";
import VuetablePagination from "vuetable-2/src/components/VuetablePagination";
import Pagination from "@/components/pagination";
import BannerActions from "@/modules/banner/components/BannerActions";
export default {
  name: "BannerAdminIndex",

  components: {
    BannerActions,
    Pagination,
    VuetablePagination,
  },
  data() {
    return {
      loading: true,
      searchQuery: null,
      table: {
        fields: [
          {
            name: "title",
            titleClass: "u-ta-left",
            title: "Banner Title",
            width: "30%",
          },
          {
            name: "date-created",
            titleClass: "u-ta-left",
            title: "Date Created",
            width: "20%",
          },
          {
            name: "category-actions",
            title: "Actions",
            titleClass: "u-ta-center u-hide-mobile",
            dataClass: "u-ta-center u-hide-mobile",
            width: "10%",
          },
        ],
      },
    };
  },

  computed: {
    ...mapState("Banner", ["pagination", "banners"]),
  },

  watch: {
    banners(newValue, oldValue) {
      if (newValue && newValue.length !== oldValue.length) {
        this.updateTable();
      }
    },
  },

  mounted() {
    this.$store.dispatch("Banner/listSliders", { flat: true }).then((resp) => {
      this.loading = false;
    });
  },
  methods: {
    onRowClass(item, index) {
      return item.status && item.status === "active" ? "bg-active" : "";
    },
    updateTable() {
      this.$refs.bannerTable.refresh();
    },
    dataManager(sortOrder, pagination) {
      const returnObj = {
        ...this.pagination,
        data: this.banners,
      };

      return returnObj;
    },
    onPaginationData(paginationData) {
      this.$refs.pagination.setPaginationData(paginationData);
    },
    onChangePage(page) {
      const vm = this;
      const tableref = vm.$refs.bannerTable;
      let nextPage;
      this.loading = true;

      switch (page) {
        case "next":
          nextPage = ++this.$store.state.News.pagination.current_page;
          break;
        case "prev":
          nextPage = --this.$store.state.News.pagination.current_page;
          break;
        default:
          nextPage = page;
          break;
      }
      this.$store
        .dispatch("Banner/listSliders", {
          includeWeb: false,
          page: nextPage,
          flat: true,
        })
        .then((resp) => {
          window.scroll(0, 0);
          tableref.changePage(nextPage);
          this.loading = false;
        });
    },
  },
};
</script>

<style lang="scss">
.bg-active {
  background: lighten($colour-nhs-light-green, 50%);
}
</style>
